import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabservice() {



  const cardData =
  {
    keyword: 'One Way Cab Service ',
    heading: 'Shambhu Cabs: One Way Cab Service',
    headingDescription: 'Shambhu Cabs offers reliable One Way Cab Service, providing safe, comfortable, and hassle-free travel for families, corporate travelers, business commuters, and solo travelers across cities and intercity routes. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and convenient journey with well-maintained vehicles and spacious seating. With flexible one-way travel options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free, punctual, and affordable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted one-way cab services for travelers seeking comfort, safety, and a reliable travel experience.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 to commemorate the visit of King George V and Queen Mary, is one of Mumbai’s most iconic landmarks. Located on the waterfront in Colaba, it features grand arches in Indo-Saracenic style, offering panoramic views of the Arabian Sea. The surrounding area is lively with street vendors, boat rides to Elephanta Island, and cultural performances, making it a must-visit for tourists exploring Mumbai’s heritage and coastal beauty."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km long boulevard along the Arabian Sea. Famous for its Art Deco buildings and stunning sunset views, it attracts joggers, families, and tourists. The promenade lights up at night, giving it the appearance of a string of pearls. Marine Drive is perfect for leisurely walks, photography, and experiencing Mumbai’s vibrant coastal life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887 in Victorian Gothic style with domes, turrets, and intricate stone carvings, it is an architectural marvel. The station symbolizes Mumbai’s colonial past and modern connectivity, serving as both a transportation hub and a tourist attraction admired for its historical and cultural significance."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple, dedicated to Lord Ganesha, is one of Mumbai’s most revered religious sites. Located in Prabhadevi, it attracts thousands of devotees daily who seek blessings and fulfillment of wishes. The temple’s idol, adorned with gold, intricate carvings, and beautiful decorations, creates a spiritual and serene atmosphere. Festivals, especially Ganesh Chaturthi, see grand celebrations, making it a cultural and religious landmark."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island near Mumbai, are UNESCO World Heritage Sites featuring rock-cut sculptures dedicated to Lord Shiva. Dating back to the 5th-8th centuries, the caves showcase intricate carvings such as the Trimurti statue, depicting the Hindu trinity. Visitors reach the island by ferry from the Gateway of India, making it a historical, cultural, and scenic destination combining art, mythology, and maritime beauty."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a mosque and tomb situated on an islet off the coast of Worli, accessible via a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts pilgrims and tourists from around the world. The white marble structure, set against the Arabian Sea, is especially picturesque during high tide and sunset. It is a symbol of Mumbai’s religious harmony and spiritual heritage."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, meaning 'Thieves Market,' is one of Mumbai’s oldest and largest flea markets, famous for antiques, vintage items, Bollywood memorabilia, and curiosities. The bustling market is a treasure trove for collectors, photographers, and bargain hunters. Strolling through its narrow lanes, visitors experience the vibrant chaos, history, and culture of Mumbai’s trading legacy, making it a must-visit for shoppers seeking unique finds."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its vibrant street food, sunset views, and lively atmosphere. Locals and tourists flock here to enjoy snacks like pav bhaji, bhel puri, and ice cream while walking along the shore. The beach is also home to cultural events, kite flying, and recreational activities, offering a relaxing escape from the bustling city life and a perfect spot for family outings and photography."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a Roman Catholic church renowned for its serene ambiance, beautiful architecture, and annual Bandra Fair. The church attracts pilgrims and tourists alike, offering stunning views of the surrounding hills and sea. Its blend of Gothic and modern architecture, along with the spiritual atmosphere, makes it a must-visit destination for those exploring Mumbai’s religious and cultural heritage."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park, located in the northern suburbs of Mumbai, is a lush green sanctuary spanning over 100 square kilometers. It houses diverse flora and fauna, including leopards, deer, and various bird species. The park features the Kanheri Caves, trekking trails, boating, and safari options. It serves as a natural escape from the urban hustle, offering wildlife encounters, historical exploration, and outdoor adventure for families and nature enthusiasts."
  }
],




"services": [
  {
    "name": "One-Way Taxi Near Me",
    "description": "One-Way Taxi Near Me provides quick and convenient access to reliable one-way taxi services across Mumbai. Ideal for travelers who need a single-direction ride, the service includes well-maintained sedans, SUVs, and AC cars with professional drivers. Flexible booking options, competitive pricing, and timely pickups make it perfect for airport transfers, business trips, or personal travel without the hassle of round trips."
  },
  {
    "name": "One-Way Cab Mumbai",
    "description": "One-Way Cab Mumbai offers hassle-free one-way cab services for local and outstation travel. The service includes experienced chauffeurs, clean and comfortable vehicles, and transparent fare options. Whether traveling for business, leisure, or airport transfers, customers can enjoy a smooth ride with punctual service and online booking convenience."
  },
  {
    "name": "Mumbai One-Way Outstation Cab",
    "description": "Mumbai One-Way Outstation Cab specializes in long-distance single-direction travel from Mumbai to nearby cities and towns. The service features luxury sedans, SUVs, and budget-friendly options, with professional drivers trained for intercity travel. Transparent pricing, timely pickups, and optional vehicle amenities ensure a comfortable and stress-free journey."
  },
  {
    "name": "Affordable One-Way Cab",
    "description": "Affordable One-Way Cab provides budget-friendly one-way taxi services without compromising on comfort or safety. The service includes sedans and SUVs with skilled chauffeurs, flexible scheduling, and clear fare structures. Ideal for airport transfers, local trips, and intercity travel, this service ensures reliable and economical transportation."
  },
  {
    "name": "Best One-Way Taxi Service",
    "description": "Best One-Way Taxi Service offers premium quality one-way cab rides with a focus on customer satisfaction. Vehicles are regularly maintained and include AC and non-AC options, SUVs, and sedans. Experienced drivers ensure a safe and smooth journey, and the service provides online booking, flexible pickup times, and transparent pricing for a stress-free travel experience."
  },
  {
    "name": "One-Way Airport Cab Mumbai",
    "description": "One-Way Airport Cab Mumbai provides timely and reliable airport transfers for passengers traveling to or from Mumbai airports. The service includes professional chauffeurs, comfortable vehicles, and real-time tracking. With options for sedans, SUVs, and luxury cars, it ensures on-time pickups, smooth rides, and hassle-free airport travel."
  },
  {
    "name": "One-Way AC Cab",
    "description": "One-Way AC Cab offers comfortable air-conditioned one-way taxi services for city and outstation travel. Customers can choose from well-maintained sedans or SUVs with professional drivers. The service ensures timely pickups, transparent fares, and a relaxed journey, making it perfect for business trips, airport transfers, or leisure travel."
  },
  {
    "name": "Sedan One-Way Taxi",
    "description": "Sedan One-Way Taxi provides sleek and comfortable sedans for one-way trips in and around Mumbai. The service features professional chauffeurs, on-time pickups, and clean, well-maintained vehicles. Ideal for single passengers, families, or corporate travelers, it offers a smooth, economical, and reliable travel experience."
  },
  {
    "name": "SUV One-Way Cab",
    "description": "SUV One-Way Cab offers spacious and comfortable SUV options for one-way travel in Mumbai and nearby destinations. Perfect for group travel or family trips, the service includes experienced drivers, clean vehicles, and flexible scheduling. Transparent fares, timely pickups, and a smooth ride ensure stress-free transportation."
  },
  {
    "name": "Expressway One-Way Cab",
    "description": "Expressway One-Way Cab provides high-speed and comfortable one-way travel via Mumbai’s expressways. The service includes sedans and SUVs with skilled drivers experienced in long-distance routes. Transparent pricing, punctual service, and a safe driving approach make it ideal for time-sensitive trips and intercity travel."
  },
  {
    "name": "Long Distance One-Way Cab",
    "description": "Long Distance One-Way Cab specializes in single-direction intercity travel from Mumbai to nearby cities and towns. The service offers a variety of vehicles, including luxury sedans, SUVs, and budget options, all driven by professional chauffeurs. Reliable scheduling, comfortable interiors, and competitive fares make it perfect for business or leisure travel."
  },
  {
    "name": "Quick One-Way Cab Booking",
    "description": "Quick One-Way Cab Booking allows customers to book one-way taxi services instantly through an online platform. The service provides fast confirmation, multiple vehicle options, and professional chauffeurs. Ideal for last-minute travel, airport pickups, or intercity trips, it ensures convenience, reliability, and comfort."
  },
  {
    "name": "24×7 One-Way Taxi Service",
    "description": "24×7 One-Way Taxi Service offers round-the-clock availability for one-way trips in and out of Mumbai. The service features sedans, SUVs, and AC cabs with professional drivers, ensuring flexible scheduling and reliable service anytime. Perfect for urgent travel, airport transfers, or long-distance trips at any hour."
  },
  {
    "name": "Cheap One-Way Taxi",
    "description": "Cheap One-Way Taxi provides economical one-way taxi options without compromising safety or comfort. The service includes sedans and SUVs, well-maintained vehicles, professional drivers, and transparent fare options. Ideal for budget-conscious travelers needing reliable and affordable single-direction transport."
  },
  {
    "name": "One-Way Ride Mumbai",
    "description": "One-Way Ride Mumbai offers hassle-free single-direction taxi services across the city and nearby destinations. The service features professional chauffeurs, comfortable vehicles, and flexible booking options. Perfect for airport transfers, business trips, or leisure travel, it ensures a smooth and timely journey."
  },
  {
    "name": "Online One-Way Cab Booking",
    "description": "Online One-Way Cab Booking enables customers to reserve one-way taxi rides conveniently through a digital platform. The service provides multiple vehicle choices, real-time fare estimates, and professional chauffeurs. Ideal for travelers seeking a fast, reliable, and contactless booking experience."
  },
  {
    "name": "Trusted One-Way Cab",
    "description": "Trusted One-Way Cab delivers dependable one-way taxi services with verified drivers and well-maintained vehicles. The service focuses on punctuality, safety, and comfort, making it ideal for airport transfers, corporate travel, or personal trips. Transparent pricing and professional service ensure complete peace of mind."
  }
],

"tableData": [
  ["One-Way Taxi Near Me", "One-Way Cab Mumbai"],
  ["Mumbai One-Way Outstation Cab", "Affordable One-Way Cab"],
  ["Best One-Way Taxi Service", "One-Way Airport Cab Mumbai"],
  ["One-Way AC Cab", "Sedan One-Way Taxi"],
  ["SUV One-Way Cab", "Expressway One-Way Cab"],
  ["Long Distance One-Way Cab", "Quick One-Way Cab Booking"],
  ["24×7 One-Way Taxi Service", "Cheap One-Way Taxi"],
  ["One-Way Ride Mumbai", "Online One-Way Cab Booking"],
  ["Trusted One-Way Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "One Way Cab Service with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable one-way cab services, perfect for point-to-point travel, airport transfers, and convenient intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to ensure a comfortable and safe one-way journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Smooth Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with major routes, ensuring timely, safe, and hassle-free one-way travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making your one-way cab booking worry-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route guidance, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from customized one-way travel plans to suit your schedule and destination requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your one-way journey comfortable, easy, and stress-free."
  }
]





















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide one way cab services?',
    answer: 'Yes, Shambhu Cabs offers convenient and reliable one way cab services for local and outstation travel, ensuring a comfortable journey without return hassles.',
  },
  {
    question: 'How can I book a one way cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'What types of vehicles are available for one way cab service?',
    answer: 'Shambhu Cabs offers sedans, SUVs, and premium cars suitable for individual, family, and group travel on one way trips.',
  },
  {
    question: 'Are drivers experienced for one way cab journeys?',
    answer: 'Yes, our drivers are licensed, professional, and experienced with both local and long-distance routes for safe and timely travel.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for a one way cab?',
    answer: 'Absolutely. You can select any pickup and drop-off points according to your travel requirements.',
  },
  {
    question: 'Is the one way cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock one way cab services to fit your schedule and travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed for one way cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines for passenger well-being.',
  },
  {
    question: 'What payment options are available for one way cab services?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options for one way cab bookings.',
  },
  {
    question: 'Is customer support available during one way cab journeys?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your one way cab travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'The one way cab service by Shambhu Cabs was very convenient and comfortable. The driver was professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Singh',
    feedback: 'Highly satisfied with Shambhu Cabs’ one way cab service. Smooth ride and excellent service throughout.',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Service",
  "image": "https://www.shambhucab.com/assets/images/one-way-cab-service.jpg",
  "description": "Shambhu Cabs provides reliable one-way cab services in Mumbai for airport transfers, city travel, and long-distance trips. Choose from AC, sedan, SUV, and expressway cabs for safe, affordable, and quick one-way rides. Available 24×7 with online booking and trusted chauffeur-driven service.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/one-way-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>One Way Cab Service Mumbai | Airport & Outstation | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book one-way cab service in Mumbai with Shambhu Cabs. Affordable and reliable rides for airport transfers, city travel, and long-distance trips. AC, sedan, SUV cabs available 24×7 with online booking."
  />

  <meta
    name="keywords"
    content="One-Way Taxi Near Me, One-Way Cab Mumbai, Mumbai One-Way Outstation Cab, Affordable One-Way Cab, Best One-Way Taxi Service, One-Way Airport Cab Mumbai, One-Way AC Cab, Sedan One-Way Taxi, SUV One-Way Cab, Expressway One-Way Cab, Long Distance One-Way Cab, Quick One-Way Cab Booking, 24×7 One-Way Taxi Service, Cheap One-Way Taxi, One-Way Ride Mumbai, Online One-Way Cab Booking, Trusted One-Way Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabservice;